<template>
  <el-container>
    <el-pagination background
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="pageSizes"
                   :page-size.sync="currentPageSize"
                   :layout="layout"
                   :total="total">
    </el-pagination>
  </el-container>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    props: {
      currentPage: {
        type: Number,
        default: 1
      },
      total: {
        type: Number,
        default: 0
      },
      pageSizes: {
        type: Array,
        default: function () {
          return [10, 20, 50, 100, 200, 300, 400]
        }
      },
      pageSize: {
        type: Number,
        default: 20
      },
      handleSizeChange: {
        type: Function,
        default: function(val) {
          console.log(`每页 ${val} 条`);
        }
      },
      handleCurrentChange: {
        type: Function,
        default: function(val) {
          console.log(`当前页: ${val}`);
        }
      },
      layout: {
        type: String,
        default: "total, prev, pager, next, jumper",
        defaultBack: "total, sizes, prev, pager, next, jumper"
      }
    },
    methods: {
    },
    computed: {
      currentPageSize: {
        get() {
          return this.pageSize
        },
        set(newVal) {
          this.$emit('update:pageSize', newVal)
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue